{
  "FormEngineRadiosElement": {
    "title": "Radios"
  },
  "mask": {
    "FormEngineRadiosElement": {
      "groupTitle": "Radios",
      "inline": "In der Reihe",
      "datasource": "Optionen",
      "datasourceExpressions": "Optionsfilter"
    }
  }
}